const common = {
  "site.name": "楼凤论坛",
  "site.tagline": "用户交流与资讯聚合平台",
  "nav.home": "首页",
  "nav.categories": "分类浏览",
  "nav.about": "关于我们",
  "nav.search": "搜索文章...",
  "nav.login": "登录",
  "nav.register": "注册",
  "footer.copyright": "© 2024 楼凤论坛 版权所有",
  "footer.about": "关于我们",
  "footer.privacy": "隐私政策",
  "footer.terms": "用户协议",
  "footer.contact": "联系我们",
  "footer.description": "楼凤论坛是汇聚用户真实体验、资讯分享与社区交流的综合性论坛平台。",
  "breadcrumb.home": "首页",
  "scroll.top": "返回顶部",
};

export default common;